<template>
    <div>
        <section class="section-container">
            <div class="download-wrapper">
                <div class="page-top">
                    <div class="content-box clearfix">
                        <img
                            class="content-box-img"
                            :class="{'pc-box-img': tabIndex<=1}"
                            :src="img_list[tabIndex]"
                            alt=""
                        >
                        <div id="fade_image" class="download clearfix">
                            <div class="download__title">{{title_list[tabIndex]}}</div>
                            <div class="download__desc">{{desc_list[tabIndex]}}</div>
                            <a
                                v-if="tabIndex===0"
                                class="download__btn"
                                :href="windowsDownloadUrl"
                            >
                                Windows版本下载
                            </a>
                            <div v-if="tabIndex===1" class="download__btn-group">
                                <div class="download__btn" @click="macDownload('GTSY_INTEL')">Intel芯片版</div>
                                <div class="download__btn" @click="macDownload('GTSY_APPLE')">Apple芯片版</div>
                            </div>
                            <div v-if="tabIndex>1" class="download__qrcode">
                                <div class="download__qrcode">
                                    <img :src="qr_list[tabIndex]" alt="qrcode">
                                    <div>手机浏览器扫码 立即下载</div>
                                </div>
                            </div>
                            <a v-if="tabIndex===0" class="low-ver" :href="windows32DownloadUrl">32位版本下载</a>
                            <div v-if="tabIndex===0" class="win-info">适用于Win7及以上系统，处理器i3及以上，运行内存4G及以上，建议使用五年以内的设备</div>
                        </div>
                    </div>
                    <div class="tab-btn">
                        <ul>
                            <li
                                v-for="(item,index) in tab_list"
                                :key="index"
                                v-clickReport="item.enId"
                                style="cursor: pointer;"
                                :class="{active: index == tabIndex}"
                                @click="tabHandler(index)"
                            >
                                <i :class="`icon iconfont ${tabIcon[index]}`"></i>
                                <span>{{item.name}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- <div class="video">
                    <div class="video-top-title">使用指南</div>
                    <div class="underline"></div>
                    <video
                        src="https://imgs.genshuixue.com/0baijiatools/9db894dbcbbae8c87934f04b2d55f03d/app.mp4"
                        controls="controls"
                        class="video-content"
                    ></video>
                </div> -->
                <modal name="xp-system-popup" transition="nice-modal-fade" width="588" height="294">
                    <div class="common-popup-modal">
                        <div
                            class="popup__head"
                        >
                            提示<i class="icon iconfont icon-guanbi" @click="$modal.hide('xp-system-popup')"></i>
                        </div>
                        <div class="popup__body">
                            <div class="modal__text">高途电脑客户端不支持XP系统， 请升级电脑系统至Win7及以上版本或用手机客户端进行上课。</div>
                            <div class="modal-btn" @click="$modal.hide('xp-system-popup')">确定</div>
                        </div>
                    </div>
                </modal>
                <modal name="windows-system-popup" transition="nice-modal-fade" width="588" height="294">
                    <div class="common-popup-modal">
                        <div
                            class="popup__head"
                        >
                            提示<i class="icon iconfont icon-guanbi" @click="$modal.hide('windows-system-popup')"></i>
                        </div>
                        <div class="popup__body">
                            <div class="modal__text">您的电脑系统为Windows系统，请下载Windows客户端。</div>
                            <div class="modal-btn" @click="$modal.hide('windows-system-popup')">确定</div>
                        </div>
                    </div>
                </modal>
            </div>
        </section>
    </div>
</template>

<script>
import {isWindows64Bit, isWindows7} from '@base/util/common';
import {WINDOWS_DOWNLOAD_URLS, MAC_DOWNLOAD_URLS} from '@base/constants/common';
import windowsImg from '~/assets/img/windows.png';
import macImg from '~/assets/img/mac.png';
import iosImg from '~/assets/img/ios.png';
import androidImg from '~/assets/img/android.png';
import config from '~/environment';

// 高途下载页
const ApolloConfigId = process.env.PATH_TYPE === 'master' ? '6426909505680457462' : '6445636686608592787';
const APOLLO_URL = `https://hydra-cdn.gaotu100.com/activity-fe/${ApolloConfigId}.json?${Date.now()}`;

export default {
    async asyncData({app, req}) {
        let is64Bit = false;
        let isWin7 = false;
        try {
            const userAgent = (process.server ? req.headers['user-agent'] : navigator.userAgent) || '';
            is64Bit = isWindows64Bit(userAgent);
            isWin7 = isWindows7(userAgent);
            const {data} = await app.$axios.get(APOLLO_URL);
            if (data?.code === 0) {
                return {
                    ...data,
                    is64Bit,
                    isWin7
                };
            }
        }
        catch (e) {
            console.error({message: '下载接口错误', statusCode: 500});
        }
        return {
            is64Bit,
            isWin7
        };
    },
    data() {
        return {
            img_list: {
                0: windowsImg,
                1: macImg,
                2: iosImg,
                3: androidImg
            },
            title_list: {
                0: '高途素养电脑客户端',
                1: '高途素养电脑客户端',
                2: '高途素养移动客户端',
                3: '高途素养移动客户端'
            },
            desc_list: {
                0: '稳定、大屏、更多互动',
                1: '稳定、大屏、更多互动',
                2: '随时随地 高效学习',
                3: '随时随地 高效学习'
            },
            tab_list: [
                {name: 'Windows版', enId: 34269125},
                {name: 'Mac版', enId: 34269169},
                {name: 'iOS版', enId: 34286983},
                {name: 'Android版', enId: 34287014},
            ],
            tabIndex: 0,
            tabIcon: {
                0: 'icon-windows',
                1: 'icon-mac',
                2: 'icon-apple',
                3: 'icon-andriod'
            },
            qr_list: [
                '',
                '',
                'https://i.gsxcdn.com/2385033739_cnp1yp73.png',
                'https://i.gsxcdn.com/2385033739_cnp1yp73.png'
            ],
            // 是否为windows系统64位
            is64Bit: false,
            // 是否为windows7/8系统
            isWin7: false,
        };
    },
    computed: {
        windowsDownloadUrl() {
            const {SUYANG_WIN7_32, SUYANG_WIN7_64, SUYANG_WIN10_32, SUYANG_WIN10_64} = WINDOWS_DOWNLOAD_URLS;
            if (this.isWin7) {
                return this.is64Bit ? SUYANG_WIN7_64 : SUYANG_WIN7_32;
            }
            return this.is64Bit ? SUYANG_WIN10_64 : SUYANG_WIN10_32;
        },
        windows32DownloadUrl() {
            return this.isWin7 ? WINDOWS_DOWNLOAD_URLS.SUYANG_WIN7_32 : WINDOWS_DOWNLOAD_URLS.SUYANG_WIN10_32;
        }
    },
    mounted() {
        const ua = navigator.userAgent;
        if (ua.indexOf('Windows NT 5.1') !== -1) {
            this.$modal.show('xp-system-popup');
        }
        this.detectOS();
    },
    methods: {
        // 切换导航
        tabHandler(index) {
            this.tabIndex = index;
        },
        macDownload(type) {
            const downloadUrl = MAC_DOWNLOAD_URLS[type];
            window.location.href = downloadUrl;
        },
        detectOS() {
            const sUserAgent = navigator.userAgent || '';
            const isWin = (navigator.platform === 'Win32') || (navigator.platform === 'Windows');
            const isMac
                = (navigator.platform === 'Mac68K')
                    || (navigator.platform === 'MacPPC')
                    || (navigator.platform === 'Macintosh')
                    || (navigator.platform === 'MacIntel')
                    || '';
            const agentID = sUserAgent.toLowerCase().match(/(iphone|ipod|ipad|android)/);
            if (isMac) {
                this.tabHandler(1);
            }
            if (isWin) {
                this.tabHandler(0);
            }
            if (agentID) {
                window.location.href = `https:${config.env.mUrl}/account/download`;
            }
        },
    },
    head() {
        return {
            style: [
                {
                    cssText: 'html,body {background: #fff !important;}',
                    type: 'text/css'
                }
            ]
        };
    }
};
</script>

<style lang="less" scoped>
.page-top {
    position: relative;
    width: 100%;
    min-width: 1182px;
    height: 500px;
    background: url(~assets/img/downloadbg.png) no-repeat center center;
}

.content-box {
    position: relative;
    width: 907px;
    margin: 0 auto;
    display: flex;
    align-items: center;

    .content-box-img {
        float: left;
        width: 498px;
        height: 340px;
        padding-top: 70px;
    }

    .pc-box-img {
        padding-top: 70px;
    }

    .download {
        width: 409px;
        text-align: center;
        align-self: flex-start;
        // margin-bottom: 60px;

        .win-info {
            font-size: 12px;
            width: 364px;
            color: #999;
            margin-top: 20px;
            line-height: 20px;
            margin: 0 auto;
        }

        &__title {
            font-size: 36px;
            font-weight: 600;
            color: #565656;
            line-height: 36px;
            margin-top: 122px;
        }

        &__desc {
            font-size: 20px;
            color: #565656;
            line-height: 20px;
            margin-top: 12px;
        }

        &__compliance {
            width: 313px;
            margin: 0 auto;
            font-size: 11px;
            color: #8b8fa1;
            line-height: 17px;
            margin-top: 6px;
        }

        &__btn {
            display: inline-block; // width: 180px;
            cursor: pointer;
            height: 48px;
            padding: 0 30px;
            color: #fff;
            font-size: 20px;
            text-align: center;
            line-height: 48px;
            margin-top: 32px;
            background: linear-gradient(270deg, #f99527 0%, #feb545 100%);
            box-shadow: 0 4px 16px 0 #ff810a80;
            border-radius: 24px;
        }

        &__qrcode {
            img {
                width: 130px;
                height: 130px;
                border: 5px solid #fff;
                margin: 22px auto 12px;
            }

            div {
                font-size: 14px;
                color: #999;
                line-height: 14px;
                text-align: center;
            }
        }
    }
}

.qrcode-content {
    position: relative;
    list-style: none;
    width: 1080px;
    height: 340px;
    margin: 36px auto 0;

    li {
        width: 264px;
        height: 340px;
        float: left;
        text-align: center;
        margin: 0 48px;

        .qrcode-img {
            width: 164px;
            height: 168px;
        }

        .qrcode-title {
            font-size: 20px;
            color: #000;
            line-height: 20px;
            margin: 30px 0 14px;
        }

        .qrcode-desc {
            font-size: 16px;
            color: #999;
            line-height: 24px;
        }
    }
}

.tab-btn {
    position: absolute;
    bottom: 22px;
    z-index: 99;
    left: 50%;
    transform: translateX(-50%);

    ul {
        position: relative;
        height: 52px;
        background: #fff;
        list-style: none;
        border-radius: 4px;
        font-size: 14px;
        color: #999;

        li {
            float: left;
            width: 136px;
            height: 52px;
            list-style: none;
            text-align: center;
            line-height: 52px;
            cursor: pointer;

            i {
                display: inline-block;
                margin-bottom: 6px;
            }
        }

        li:hover {
            color: #fff;
            background: #f63232;
            box-shadow: 0 4px 16px 0 #ff000080;
        }

        .active {
            color: #fff;
            background: #f63232;
            box-shadow: 0 4px 16px 0 #ff000080;
        }

        li:first-child {
            border-radius: 4px 0 0 4px;
        }

        li:last-child {
            border-radius: 0 4px 4px 0;
        }
    }
}

.video {
    margin-top: 70px;
    margin-bottom: 54px;
    text-align: center;

    .video-top-title {
        font-size: 36px;
    }

    .underline {
        width: 44px;
        height: 3px;
        background: #fc3f3f;
        margin: 15px auto 40px;
    }

    .video-content {
        width: 866px;
        height: 489px;
    }
}

.qrcode-box {
    position: relative;
    height: 480px;
    margin: 0 auto;
    padding-top: 64px;
    box-sizing: border-box;

    .title {
        position: relative;
        text-align: center;
        font-size: 36px;
        color: #000;

        &::after {
            content: "";
            position: absolute;
            width: 42px;
            height: 4px;
            left: 50%;
            bottom: -15px;
            margin-left: -21px;
            background-color: #fc3f3f;
            border-radius: 2px;
        }
    }
}

.download__btn-group {
    display: flex;
    justify-content: center;
    align-items: center;

    .download__btn {
        &:first-child {
            margin-right: 20px;
        }
    }
}

.modal__text {
    margin: 16px 84px !important;
    font-size: 20px !important;
    line-height: 32px !important;
}

.low-ver {
    font-size: 14px;
    color: #999;
    margin-top: 16px;
    line-height: 20px;
    margin-bottom: 32px;
    cursor: pointer;
    text-decoration: underline;
    display: block;

    &:hover {
        color: #ff443d;
    }
}

.coding {
    overflow: hidden;

    &-title {
        position: relative;
        margin: 100px 0;
        text-align: center;
        font-size: 36px;
        font-weight: 400;
        color: #000;
        line-height: 36px;

        &::after {
            content: "";
            position: absolute;
            bottom: -15px;
            left: 50%;
            transform: translateX(-50%);
            width: 44px;
            height: 3px;
            background: #FC3F3F;
        }
    }

    &-content {
        display: flex;
        justify-content: center;

        .banner {
            width: 523px;
            height: 294px;
            margin-right: 150px;

            img {
                width: 100%;
            }
        }

        .download {
            text-align: center;

            &-title {
                font-size: 30px;
                font-weight: 600;
                line-height: 30px;
                color: #000;
                margin-top: 30px;
            }

            &-desc {
                font-size: 18px;
                line-height: 18px;
                margin: 20px 0 86px;
                color: #555;
            }
        }
    }

    .btn-group {
        display: flex;

        >div {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 243px;
            line-height: 70px;
            text-align: center;
            font-size: 18px;
            border-radius: 35px;
            color: #FFF;
            cursor: pointer;

            img {
                width: 26px;
                height: 26px;
                margin-right: 12px;
            }
        }

        .windows {
            background: #FF3741;
            margin-right: 40px;
        }

        .mac {
            background: #0890FF;
        }
    }
}
</style>
